module.exports = __webpack_public_path__ + "media/images/OPL 88-41794edd4ef1acf35cea473ef1a5eab3.png";